/**
 * Rekenen met werkuren, voor de planning.
 *
 * Een kar die 20 uur werk vraagt en maandag om 07:00 begint, is niet maandag om
 * 03:00 's nachts klaar maar woensdag om 09:00: alleen de werkuren op werkdagen tellen.
 *
 * Tijdstippen zijn lokaal en zonder tijdzone (`2026-10-22T07:00`), zoals de planning
 * ze bewaart: de werkplaats staat op één plek, en zo betekent 07:00 in de browser en
 * in de Azure Function hetzelfde.
 */
/** Van 07:00 tot 16:00, maandag tot en met vrijdag. Op het scherm aan te passen. */
export const STANDAARD_WERKUREN = { begin: 7 * 60, eind: 16 * 60, dagen: [1, 2, 3, 4, 5] };
/** `jjjj-mm-ddTuu:mm`, zonder seconden en zonder tijdzone. */
export const TIJDSTIP = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
export function leesTijdstip(tijdstip) {
    const [datum = '', tijd = '00:00'] = tijdstip.split('T');
    const [j, m, d] = datum.split('-').map(Number);
    const [u, mi] = tijd.split(':').map(Number);
    return new Date(j ?? 0, (m ?? 1) - 1, d ?? 1, u ?? 0, mi ?? 0);
}
const twee = (n) => String(n).padStart(2, '0');
export function schrijfTijdstip(d) {
    return `${d.getFullYear()}-${twee(d.getMonth() + 1)}-${twee(d.getDate())}T${twee(d.getHours())}:${twee(d.getMinutes())}`;
}
const minuutVanDag = (d) => d.getHours() * 60 + d.getMinutes();
function opMinuut(d, minuut) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, minuut);
}
function volgendeDag(d, minuut) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1, 0, minuut);
}
/** Zonder werkdagen of met een lege werkdag valt er niets te rekenen: dan telt de klok. */
const ongeldig = (w) => w.dagen.length === 0 || w.eind <= w.begin;
/** Het moment waarop `minuten` werkminuten na `start` op zijn. */
export function plusWerkminuten(start, minuten, w) {
    if (minuten <= 0)
        return new Date(start);
    if (ongeldig(w))
        return new Date(start.getTime() + minuten * 60_000);
    let t = new Date(start);
    let over = minuten;
    // Een werkdag per ronde; een jaar is ruim genoeg voor elke kar.
    for (let i = 0; i < 400 * 2; i++) {
        if (!w.dagen.includes(t.getDay())) {
            t = volgendeDag(t, w.begin);
            continue;
        }
        const minuut = minuutVanDag(t);
        if (minuut < w.begin)
            t = opMinuut(t, w.begin);
        else if (minuut >= w.eind) {
            t = volgendeDag(t, w.begin);
            continue;
        }
        const vandaag = w.eind - minuutVanDag(t);
        if (over <= vandaag)
            return opMinuut(t, minuutVanDag(t) + over);
        over -= vandaag;
        t = volgendeDag(t, w.begin);
    }
    return t;
}
/** Het aantal werkminuten tussen twee momenten. */
export function werkminutenTussen(start, eind, w) {
    if (eind <= start)
        return 0;
    if (ongeldig(w))
        return Math.round((eind.getTime() - start.getTime()) / 60_000);
    let totaal = 0;
    let dag = opMinuut(start, 0);
    for (let i = 0; i < 3660 && dag < eind; i++) {
        if (w.dagen.includes(dag.getDay())) {
            const van = Math.max(opMinuut(dag, w.begin).getTime(), start.getTime());
            const tot = Math.min(opMinuut(dag, w.eind).getTime(), eind.getTime());
            if (tot > van)
                totaal += (tot - van) / 60_000;
        }
        dag = volgendeDag(dag, 0);
    }
    return Math.round(totaal);
}
//# sourceMappingURL=werktijd.js.map